<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {

		created() {
			const explorer = window.navigator.userAgent
			if (explorer.indexOf("MSIE") >= 0) {
				console.log("IE") //判断是否为IE浏览器
				alert('当前浏览器不支持该网页，请更换360，火狐，谷歌，edge浏览器打开网页')
			} else if (explorer.indexOf("Firefox") >= 0) {
				console.log("Firefox") //是否为Firefox浏览器
			} else if (explorer.indexOf("Chrome") >= 0) {
				console.log("Chrome") //是否为Chrome浏览器
			} else if (explorer.indexOf("Opera") >= 0) {
				console.log("Opera") //是否为Opera浏览器
			} else if (explorer.indexOf("Safari") >= 0) {
				console.log("Safari") //是否为Safari浏览器
			}
			this.$store.dispatch('initUser')
		}
	}
</script>

<style>
	body {
		background: #2C2D35;
		padding: 0;
		margin: 0;
		position: absoluted;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	#app {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 15px !important;
	}

	.el-dialog__header {
		background-color: #ebebeb !important;
		color: #333 !important;
		font-size: 14px !important;
		padding: 10px !important;
	}

	.el-dialog__header .el-dialog__title {
		color: #333 !important;
		font-size: 14px;
		margin-left: 5px;
	}

	.el-dialog__header .el-dialog__headerbtn {
		top: 12px
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff !important;
	}

	.el-dialog__headerbtn .el-dialog__close {
		color: #333 !important;
		margin-bottom: 6px;
	}

	.el-pagination button {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}
	.el-pagination button {
		color: #fff !important;
	}

	.el-pagination button:disabled {
		color: #ccc;
	}

	.el-pager li {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table::before {
		height: 0 !important;
	}

	.footer {
		border-top: 1px solid #868686
	}

	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.home .header {
		height: 50px !important;
	}

	.centext-box .header {
		font-size: 14px;
		border-bottom: 1px solid #585858;

	}

	.el-form-item__label {
		display: flex;
		align-items: center;
	}
</style>